import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { general } from './actions/general';
import { logger } from 'redux-logger';
import { salesConfiguration } from './actions/sales-configuration';

const rootReducer = combineReducers({
  [general.name]: general.reducer,
  [salesConfiguration.name]: salesConfiguration.reducer,
});

export type AppState = ReturnType<typeof rootReducer>;

// `preloadedState` lets tests seed the store with the exact state a test needs instead of
// dispatching its way there. redux-logger is skipped under Jest so test output isn't flooded
// with every dispatched action.
const makeStore = (preloadedState?: Partial<AppState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      // eslint-disable-next-line unicorn/prefer-spread
      getDefaultMiddleware().concat(process.env.NODE_ENV === 'test' ? [] : [logger]),
    devTools: true,
  });

export type AppStore = ReturnType<typeof makeStore>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;

export default makeStore;
